import React, { useEffect, useRef, useState } from "react";
import BPService from "../../services/resource/bpService";
import Modal from "../../componentes/modal/modal";
import BPPageTabela from "./MeuBpTabela";
import { formatarMoedaBrasileira } from "../../utils/formatarMoedaBrasileira";
import { useAuth } from "../../context/authContext";
import CadastroBP from "./CadastroBP";
import { toast } from "react-toastify";

import { Dialog } from 'primereact/dialog'
import { InputNumber } from "primereact/inputnumber";
import ImportarBPModal from "./ImportarBPModal";
import UsuarioService from "../../services/resource/usuarioService";
import { Loading } from "../../componentes/loading/loading";
import { returnDate } from "../../utils/formatDate";
import DespesaService from "../../services/resource/DespesaService";
import { Dropdown } from "primereact/dropdown";
import Button from "../../componentes/button/button";
import BPLogComponent from "../bp/BPLogComponent";

export default function BPPage() {
  const service = new BPService();
  const usuarioService = new UsuarioService();
  const despesaService = new DespesaService();

  const { user } = useAuth();

  const [bplist, setBpList] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);
  const [listaDespesa, setListaDespesa] = useState([]);
  const [selectedBP, setSelectedBP] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModalDespesa, setShowModalDespesa] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalImport, setShowModalImport] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingImport, setLoadingImport] = useState(false);
  const [nota, setNota] = useState([]);
  const [mensagemImportacao, setMensagemImportacao] = useState("");
  const [viewMode, setViewMode] = useState("lista");
  const [loadingDespesa, setLoadingDespesa] = useState(false);
  const [logsBP, setLogsBP] = useState([]);
  const [showLogModal, setShowLogModal] = useState(false);
  const [loadingLogs, setLoadingLogs] = useState(false);

  const MESES = [
    "JANEIRO", "FEVEREIRO", "MARCO", "ABRIL", "MAIO", "JUNHO",
    "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO",
  ];

  useEffect(() => {
    document.title = "MyDash | Lançamento BP";

    handleUsuariosDiretores();
  }, []);

  useEffect(() => {
    fetchBp();
  }, [usuarioSelecionado])

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, [showModal]);

  const fetchBp = () => {
    setLoading(true);

    const email = usuarioSelecionado || user.sub

    service.listarMeuBP(2026, email).then(res => {
      setBpList(res.data || []);
    }).catch((err) => console.error("Erro nas requisições BP:", err))
      .finally(() => {
        setTimeout(() => setLoading(false), 400);
      });
  };

  // 🔹 Abre o modal e combina os dados de 2025 e 2026
  const openModal = (row) => {
    const valores2025 = row.valoresMensaisAnterior || {};
    const valores2026 = row.valoresMensais || {};
    const despesasMensais = row.despesasMensaisAtual || {};

    const comparativo = MESES.reduce((acc, mes) => {
      acc[mes] = {
        valor2025: valores2025[mes] || 0,
        valor2026: valores2026[mes] || 0,
        realizado2025: despesasMensais[mes] || 0
      };
      return acc;
    }, {});

    const total2025 = Object.values(valores2025).reduce((a, b) => a + (b || 0), 0);
    const total2026 = Object.values(valores2026).reduce((a, b) => a + (b || 0), 0);

    setSelectedBP({ ...row, comparativo, total2025, total2026 });
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedBP(null);
    setShowModal(false);
  };

  const desmarcarOrcamento = () => {
    service.desmarcaContaOrcada(selectedBP.id).then(res => {

      const list = [...bplist]; // cria uma cópia da lista original
      const indexof = list.findIndex(item => item.id == selectedBP.id);

      if (indexof !== -1) {
        list[indexof] = res.data; // atualiza o item com os dados retornados
        setBpList(list);
        setShowModal(false);
      } else {
        console.warn("Item não encontrado na lista.");
      }

      closeModal();
    }).catch(error => {
      console.error(error);
    })
  }

  // 🔹 Atualiza valores mensais de 2026 no modal e recalcula totais
  const handleChangeValor2026 = (mes, novoValor) => {
    setSelectedBP((prev) => {
      const comparativoAtualizado = {
        ...prev.comparativo,
        [mes]: {
          ...prev.comparativo[mes],
          valor2026: novoValor,
        },
      };

      const total2026 = Object.values(comparativoAtualizado).reduce(
        (acc, item) => acc + (item.valor2026 || 0),
        0
      );
      const total2025 = Object.values(comparativoAtualizado).reduce(
        (acc, item) => acc + (item.valor2025 || 0),
        0
      );

      return {
        ...prev,
        comparativo: comparativoAtualizado,
        total2026,
        total2025,
      };
    });
  };

  const handleSave = async () => {
    if (!selectedBP) return;
    setSaving(true);

    const payload = {
      id: selectedBP.id,
      ano: 2026,
      valoresMensais: Object.fromEntries(
        Object.entries(selectedBP.comparativo).map(([mes, dados]) => [
          mes,
          dados.valor2026,
        ])
      ),
    };

    service.atualizarValoresMensais(payload).then(res => {
      const list = [...bplist]; // cria uma cópia da lista original
      const indexof = list.findIndex(item => item.id == selectedBP.id);

      if (indexof !== -1) {
        list[indexof] = res.data; // atualiza o item com os dados retornados
        setBpList(list);
        setShowModal(false);
      } else {
        console.warn("Item não encontrado na lista.");
      }
    }).catch(err => {
      console.error("Erro ao salvar alterações: ", err);
    }).finally(() => {
      setSaving(false);
    });
  };

  const FileDownload = require('js-file-download');

  const exportarExcel = (selectedFilters) => {

    service.exportExcelPorAno({
      ano: 2026,
      centroCusto: selectedFilters.centroCusto,
      contaContabil: selectedFilters.conta,
      filial: selectedFilters.filial,
      responsavel: [user.nome],
      email: [user.sub]
    }).then(response => {
      FileDownload(response.data, "BP " + user.nome + ".xlsx");
    }).catch(error => {
      console.error(error.message);
    })
  }

  function importarExcel(e) {
    setLoadingImport(true);
    const file = e.files[0];
    const formData = new FormData();
    formData.append("file", file);

    service.importarExcel(formData, user.id)
      .then((res) => {
        setMensagemImportacao(res);
        fetchBp();
      })
      .catch(() => console.error("Erro ao importar planilha."))
      .finally(() => {
        setLoadingImport(false);
      });
  }

  function marcarComoOrcado() {
    setLoading(true);
    service.marcarComoOrcado(user.id, 2026)
      .then(response => {
        fetchBp(); // Atualiza a lista
        toast.success(`Marcação concluída! ${response.data.registrosAlterados} registros alterados.`);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  function desmarcarComoOrcado() {
    setLoading(true);
    service.desmarcarComoOrcado(user.id, 2026)
      .then(response => {
        fetchBp(); // Atualiza a lista
        toast.success(`Desmarcação concluída! ${response.data.registrosAlterados} registros alterados.`);
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  const consultarLogs = async () => {
    if (!selectedBP?.id) return;

    setLoadingLogs(true);

    try {
      const res = await service.buscarLogBP(selectedBP.id);
      setLogsBP(res.data);
      setShowLogModal(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingLogs(false);
    }
  };

  const handleUsuarios = () => {
    usuarioService.listarUsuarios().then(res => {
      setUsuarios(res.data);
    })
  }

  const handleUsuariosDiretores = () => {
    usuarioService.listarUsuariosDiretores().then(res => {
      setUsuarios(res.data);
    })
  };

  const fecharModal = () => {
    setShowModalDespesa(false);
    setListaDespesa([]);
    setViewMode('lista')
  }

  const abrirNotaCompleta = (historico, data) => {
    setLoadingDespesa(true);
    despesaService.listaPorHistorico({
      historico: historico,
      data: data
    }).then(res => {
      setNota(res.data);
      setViewMode("nota");
    }).finally(() => setLoadingDespesa(false));
  };

  const voltarLista = () => {
    setViewMode("lista");
    setNota([]);
  };

  const valorTotalDespesa = listaDespesa.reduce(function (acumulador, obj) {
    return acumulador + obj.valor;
  }, 0);


  return (
    <div className="bg-gray-50 min-h-screen p-6">

      <div className="flex justify-end w-full pb-2">
        <Dropdown
          placeholder="Nenhum usuário selecionado..."
          filter
          options={usuarios}
          optionLabel="nome"
          optionValue="email"
          onChange={(e) => setUsuarioSelecionado(e.target.value)}
          value={usuarioSelecionado}
        />
      </div>

      <BPPageTabela data={bplist}
        openModal={openModal}
        loading={loading}
        onModalExcel={() => setShowModalImport(true)}
        exportarPlanilha={exportarExcel}
        marcarComoPendente={desmarcarComoOrcado}
        marcarComoRealizado={marcarComoOrcado}
        service={service}
        fetch={fetchBp}
        handleUsuarios={handleUsuarios}
        usuarios={usuarios}
        usuario={user}
      />

      {showModal && selectedBP && (
        <Dialog
          visible={showModal}
          onHide={closeModal}
          closeOnEscape={false}
          focusOnShow={false}
          header={
            <div className="flex flex-wrap items-center justify-between gap-3 text-xs font-medium">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-slate-100 text-slate-700 border border-slate-200 px-3 py-1">
                  {selectedBP.filialNome}
                </span>
                <span className="rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200 px-3 py-1">
                  ({selectedBP.contaReduzido}) {selectedBP.contaDescricao}
                </span>
                <span className="rounded-full bg-teal-50 text-teal-700 border border-teal-200 px-3 py-1">
                  ({selectedBP.centroCustoCodigo}) {selectedBP.centroCustoDescricao}
                </span>
                <span className="rounded-full bg-slate-100 text-slate-600 border border-slate-200 px-3 py-1">
                  {selectedBP.grupoDescricao || "Sem grupo"}
                </span>
                <span className="rounded-full bg-slate-100 text-slate-600 border border-slate-200 px-3 py-1">
                  {selectedBP.contaTipo}
                </span>
                <span className="rounded-full bg-slate-100 text-slate-600 border border-slate-200 px-3 py-1">
                  {selectedBP.responsavelNome}
                </span>
              </div>

              <div className="flex flex-wrap items-center gap-2 pl-3 border-l border-slate-200">
                {selectedBP.compartilhado && (
                  <span className="rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 px-3 py-1">
                    Compartilhado para: {selectedBP.usuarioCompartilhado}
                  </span>
                )}

                {selectedBP.contaOrcada ? (
                  <span className="rounded-full bg-emerald-100 text-emerald-800 border border-emerald-300 px-3 py-1 font-semibold">
                    Realizado
                  </span>
                ) : (
                  <span className="rounded-full bg-amber-100 text-amber-800 border border-amber-300 px-3 py-1 font-semibold">
                    Pendente
                  </span>
                )}
              </div>
            </div>
          }
          footer={
            <div className="flex gap-2 justify-between pt-3">
              <div className="flex gap-2">
                <Button disabled={saving} label="Desmarcar Orçamento" variant="white" onClick={desmarcarOrcamento} />
                <Button
                  disabled={loadingLogs}
                  label="Consultar LOG"
                  variant="white"
                  onClick={consultarLogs}
                />              </div>
              <div className="flex justify-end gap-2">
                <Button
                  variant="gray"
                  disabled={saving}
                  label="Cancelar"
                  iconLeft="fa fa-arrow-left"
                  onClick={closeModal} />
                <Button
                  label={"Confirmar Alterações"}
                  disabled={saving}
                  iconLeft="fa fa-thumbs-up"
                  loading={saving}
                  onClick={handleSave}
                  variant="indigo" />
              </div>
            </div>
          }
          style={{ width: '98%', height: '98%', maxHeight: '200vw' }}
        >
          <div className="px-3 py-1">
            <h4 className="text-lg font-semibold text-gray-800 mb-2">Orçamentos Mensais</h4>


            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 ">
              {MESES.map((mes) => {
                const { valor2025, valor2026, realizado2025 } = selectedBP.comparativo[mes];

                let variacao = 0;

                if (valor2025 > 0) {
                  variacao = (((valor2026 - valor2025) / valor2025) * 100).toFixed(2);
                } else if (valor2025 === 0 && valor2026 > 0) {
                  variacao = "+100.00"
                } else if (valor2025 === 0 && valor2026 === 0) {
                  variacao = "0.00";
                } else {
                  variacao = "-100.00";
                }

                return (
                  <div key={mes} className="bg-gray-50 rounded-xl border border-slate-200 shadow-sm p-3 flex flex-col gap-2"                  >
                    <h5 className="text-sm font-medium text-gray-700 mb-1">{mes}</h5>

                    {/* Campo 2026 (editável) */}
                    <div className="flex gap-2 items-center mb-1">
                      <label className="text-xs text-gray-600 w-10 pt-2">2026:</label>
                      <InputNumber
                        value={valor2026}
                        onValueChange={(e) => handleChangeValor2026(mes, e.value ?? 0)}
                        mode="decimal"
                        minFractionDigits={2}
                        maxFractionDigits={2}
                        locale="pt-BR"
                        onFocus={(e) => e.target.select()}
                        inputClassName="w-full min-w-0 text-right"
                      />
                    </div>

                    {/* Campo 2025 (somente leitura) */}
                    <div className="flex justify-between items-center vertical-middle">
                      <label className="text-xs text-gray-600 w-10 pt-2">2025:</label>

                      <span className=" w-full px-2 py-1  rounded text-xs text-right">
                        R$ {formatarMoedaBrasileira(valor2025) || '0,00'}
                      </span>
                    </div>

                    <div
                      className={`flex gap-2 justify-between  items-center vertical-middle rounded ${realizado2025 > valor2025 ? 'bg-red-100 text-red-600' : 'bg-gray-100'}`}
                    >
                      <label className="text-xs  w-10 pt-2 ml-1">Realizado:</label>

                      <span className=" w-full px-2 py-1  rounded text-xs text-right">
                        R$ {formatarMoedaBrasileira(realizado2025) || '0,00'}
                      </span>
                    </div>

                  </div>
                );
              })}
            </div>

          </div>

        </Dialog>
      )}

      <ImportarBPModal
        show={showModalImport}
        close={() => {
          setMensagemImportacao("");
          setShowModalImport(false)
        }}
        importarExcel={importarExcel}
        loadingImport={loadingImport}
        importMessage={mensagemImportacao}
      />
      <Modal
        title="Editar Conta BP"
        subtitle="Editar Gestor da Conta BP"
        isOpen={showModalEdit}
        width="w-[95%]"
        onClose={() => setShowModalEdit(false)}
      >
        <CadastroBP setShowModal={setShowModalEdit} modo="editar" bpSelecionado={selectedBP} />
      </Modal>

      <Dialog
        visible={showLogModal}
        onHide={() => setShowLogModal(false)}
        header="Histórico de Alterações"
        className="w-[95%]"
      >
        <BPLogComponent logsBP={logsBP} />
      </Dialog>

      <Modal
        isOpen={showModalDespesa}
        title={
          viewMode === "lista"
            ? "Despesas - "
            : "Lançamento Detalhado"
        }
        subtitle={""
        }
        onClose={fecharModal}
        footer={
          <div className="flex justify-between items-center">
            <div className="text-sm text-gray-500">
              {viewMode === "lista" && (
                <>
                  Total: <span className="font-medium">R$ {formatarMoedaBrasileira(valorTotalDespesa)}</span>
                </>
              )}
              {viewMode === "nota" && (
                <>
                  Total da Nota:&nbsp;
                  <span className="font-medium">
                    R$ {formatarMoedaBrasileira(
                      nota.reduce((acc, item) => acc + (item.valor || 0), 0)
                    )}
                  </span>
                </>
              )}
            </div>

            <div className="flex gap-2 mt-3">
              {viewMode === "nota" && (
                <Button
                  label="Voltar"
                  variant="gray"
                  iconLeft="fa fa-arrow-left"
                  onClick={voltarLista}
                />
              )}
              <Button
                label="Fechar"
                variant="indigo"
                onClick={fecharModal}
              />
            </div>
          </div>
        }
      >
        <div className="overflow-x-auto">
          {viewMode === "lista" ? (
            // === TABELA DE DESPESAS ===
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Histórico</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Centro Custo</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conta Contábil</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                  <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Ver Lançamento</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {loadingDespesa ? (
                  <tr><td colSpan={6}><Loading /></td></tr>
                ) : listaDespesa.length > 0 ? (
                  (() => {
                    const grouped = {};
                    listaDespesa.forEach((item) => {
                      const date = new Date(item.data);
                      const key = date.toLocaleString('pt-BR', { month: 'long', year: 'numeric' });
                      if (!grouped[key]) grouped[key] = [];
                      grouped[key].push(item);
                    });

                    return Object.entries(grouped).map(([mes, despesas], i) => (
                      <React.Fragment key={i}>
                        <tr>
                          <td colSpan={6} className="bg-gray-100 text-gray-700 font-semibold px-4 py-2">
                            {mes.charAt(0).toUpperCase() + mes.slice(1)}
                          </td>
                        </tr>
                        {despesas.map((data, j) => (
                          <tr key={`${i}-${j}`} className="fade-in">
                            <td className="px-4 py-3 text-sm text-gray-500">{returnDate(data.data)}</td>
                            <td className="px-4 py-3 text-sm text-gray-900">{data.historico}</td>
                            <td className="px-4 py-3 text-sm text-gray-500 text-center">{data.centroCustoCodigo}</td>
                            <td className="px-4 py-3 text-sm text-gray-500 text-center">{data.contaContabilReduzido}</td>
                            <td className="px-4 py-3 text-left text-sm font-medium text-gray-900">R$ {formatarMoedaBrasileira(data.valor)}</td>
                            <td className="px-4 py-3 text-sm text-indigo-600 text-center cursor-pointer hover:underline"
                              onClick={() => abrirNotaCompleta(data.historico, data.data)}>
                              Ver Lançamento
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ));
                  })()
                ) : (
                  <tr><td colSpan={6} className="text-center text-gray-500 py-4">Nenhuma despesa encontrada.</td></tr>
                )}
              </tbody>
            </table>
          ) : (
            // === TABELA DE NOTA DETALHADA ===
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Histórico</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Centro Custo</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conta Contábil</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {loadingDespesa ? (
                  <tr><td colSpan={5}><Loading /></td></tr>
                ) : nota.length > 0 ? (
                  nota.map((item, i) => (
                    <tr key={i}>
                      <td className="px-4 py-3 text-sm text-gray-500">{returnDate(item.data)}</td>
                      <td className="px-4 py-3 text-sm text-gray-900">{item.historico}</td>
                      <td className="px-4 py-3 text-sm text-gray-500 text-center">{item.centroCustoCodigo}</td>
                      <td className="px-4 py-3 text-sm text-gray-500 text-center">{item.contaContabilReduzido}</td>
                      <td className="px-4 py-3 text-left text-sm font-medium text-gray-900">R$ {formatarMoedaBrasileira(item.valor)}</td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan={5} className="text-center text-gray-500 py-4">Nenhum lançamento encontrado.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </Modal>
    </div>
  );
}

// Função utilitária para parsear "{ABRIL=4143.82, AGOSTO=4143.82, ...}"
function parseValorMapa(valor) {
  if (!valor || typeof valor !== "string" || !valor.startsWith("{")) {
    return null;
  }
  const conteudo = valor.replace(/^{|}$/g, "").trim();
  if (!conteudo) return null;

  return conteudo.split(",").map((par) => {
    const [chave, ...resto] = par.trim().split("=");
    return { chave: chave.trim(), valor: resto.join("=").trim() };
  });
}

function formatarMoeda(valor) {
  const num = Number(valor);
  if (isNaN(num)) return valor;
  return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

// Componente para renderizar o valor (mapa ou texto simples)
function ValorLog({ valor, cor }) {
  const mapa = parseValorMapa(valor);

  if (!mapa) {
    return <p className={`text-sm ${cor} break-words`}>{valor || "—"}</p>;
  }

  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-1 mt-1">
      {mapa.map(({ chave, valor: v }) => (
        <div key={chave} className="flex items-center justify-between text-xs">
          <span className="text-slate-400 capitalize">{chave.toLowerCase()}</span>
          <span className={`font-semibold ${cor}`}>{formatarMoeda(v)}</span>
        </div>
      ))}
    </div>
  );
}